import { useMemo } from "react";
import { HOTEL_CHECKOUT_HTS_EVENT_TRANSFORMER_HOOKS } from "@b2bportal/core-checkout";
import { HOTEL_HTS_EVENT_TRANSFORMER_HOOKS } from "@b2bportal/core-hotels";
import { CORE_COMMON_HTS_EVENT_TRANSFORMER_HOOKS } from "@b2bportal/core-tracking";
import {
  createUseEmitRawEvent,
  mergeEventTransformerHooks,
  TrackingProvider,
  usePublishHTSEvent,
} from "@b2bportal/core-tracking";
import { usePublishPerkspotEvent } from "@/utils/tracking";

const useEmitHTSEvent = createUseEmitRawEvent({
  transformerHooks: mergeEventTransformerHooks(
    CORE_COMMON_HTS_EVENT_TRANSFORMER_HOOKS,
    HOTEL_HTS_EVENT_TRANSFORMER_HOOKS,
    HOTEL_CHECKOUT_HTS_EVENT_TRANSFORMER_HOOKS
  ),
  usePublishEvent: usePublishHTSEvent,
});

const useEmitPerkspotEvent = createUseEmitRawEvent({
  transformerHooks: mergeEventTransformerHooks(
    CORE_COMMON_HTS_EVENT_TRANSFORMER_HOOKS,
    HOTEL_HTS_EVENT_TRANSFORMER_HOOKS,
    HOTEL_CHECKOUT_HTS_EVENT_TRANSFORMER_HOOKS
  ),
  usePublishEvent: usePublishPerkspotEvent,
});

export const AppTrackingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const emitRawEventHooks = useMemo(
    () => [useEmitHTSEvent, useEmitPerkspotEvent],
    []
  );

  return (
    <TrackingProvider emitRawEventHooks={emitRawEventHooks}>
      {children}
    </TrackingProvider>
  );
};
